import React, { FC, ReactNode } from "react";
import cn from "classnames";
import { GlobalNavigationProps } from "../GlobalNavigation";
import { Link as LinkProps } from "@/types";
import Link from "@/components/Link";

type MenuTabItem = {
  title?: string;
  links?: LinkProps[];
  cta?: ReactNode;
  setSubTab?: (num: number) => void;
  closeMenu?: () => void;
} & Partial<Pick<GlobalNavigationProps, "superHeader">>;

const MobileNavigationMenuTabItem: FC<MenuTabItem> = ({
  title,
  links,
  cta,
  closeMenu,
}) => {
  return (
    <div className="border-swdc-silver-300 text-subhead-2xs text-swdc-black-600 border-l-8 border-solid">
      {title && <div className={cn("py-4 pr-6 pl-4 font-bold")}>{title}</div>}
      {!!links && (
        <ul>
          {links?.map(
            ({ title, ...delegated }, index) =>
              title &&
              delegated.href &&
              closeMenu && (
                <li key={`${title}-${index}`}>
                  <Link
                    className="text-subhead-2xs text-swdc-black-600 active:text-swdc-blue-500 flex w-full py-4 pr-6 pl-4 hover:underline active:underline"
                    {...delegated}
                    href={delegated.href ?? ""}
                    onClick={closeMenu}
                  >
                    {title}
                  </Link>
                </li>
              ),
          )}
        </ul>
      )}
      {cta && <div className="py-4 pr-5 pl-4">{cta}</div>}
    </div>
  );
};

export default MobileNavigationMenuTabItem;
